import React from "react";
import DropDown from "../ReusableComponents/DropDown";

const OpeningstockPopup = ({ data, data1 }) => {
  // Destructure data array
  const [itemTypeId, filterItemType, filterItemCategory, filterItemName, uom] = data || [];

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Fallback item type options (optional, remove if not needed)
  const itemTypeOptions = [
    { label: "Fixed Asset", value: "1" },
    { label: "Consumable", value: "2" },
  ];

  return (
    <div className="w-full">
      <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
        <div className="sm:grid gap-4 mb-6 md:grid-cols-3">
          {/* Header Dropdown */}
          <div className="w-full md:w-3/4 space-y-6 mb-6">
            <DropDown
              title="Item Type"
              name="itemtype"
              type="select-one"
              classStar="text-red-500"
              selectedOption={filterItemType?.[0]?.value || itemTypeId}
              options={filterItemType?.length > 0 ? filterItemType : itemTypeOptions}
              disabled={true}
            />
          </div>
        </div>

        {/* Table */}
        <div className="w-full overflow-x-auto overflow-y-auto">
          <table className="min-w-[1000px] border border-gray-300">
            <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
              <tr>
                <th className="border px-4 py-2">S.No</th>
                <th className="border px-4 py-2">Item Category</th>
                <th className="border px-4 py-2">Name</th>
                <th className="border px-4 py-2">Date of Opening Stock</th>
                <th className="border px-4 py-2">Quantity</th>
                <th className="border px-4 py-2">U.O.M.</th>
                <th className="border px-4 py-2">Value</th>
              </tr>
            </thead>
            <tbody>
              {data1 && data1.length > 0 ? (
                data1.map((row, index) => (
                  <tr key={index}>
                    <td className="border px-2 py-2 text-center">{index + 1}</td>
                    <td className="border px-2 py-2 text-center">
                      {row.MstItemCategoryName || "N/A"}
                    </td>
                    <td className="border px-2 py-2 text-center">
                      {row.MstItemName || "N/A"}
                    </td>
                    <td className="border px-2 py-2 text-center">
                      {formatDate(row.DateofOpeningStock)}
                    </td>

                    <td className="border px-2 py-2 text-center">
                      {row.Quantity || "N/A"}
                    </td>
                    <td className="border px-2 py-2 text-center">
                      {row.UOM || uom || "N/A"}
                    </td>
                    <td className="border px-2 py-2 text-center">
                      {row.Value || "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="border px-2 py-2 text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
};

export default OpeningstockPopup;